/*
  src/redux/entities/constants.js

  Created by Justin Chang on 5/16/2017.
*/

import { createConstant } from '../helpers';
const createConstantVariable = createConstant('campaigns');

export const SET_CAMPAIGNS     = createConstantVariable('SET_CAMPAIGNS');
export const COMPLETE_CAMPAIGN = createConstantVariable('COMPLETE_CAMPAIGN');
export const RATE_CAMPAIGN = createConstantVariable('RATE_CAMPAIGN');

// Failure Constants
export const FAIL_TO_SET_NEW_CAMPAIGNS       = createConstantVariable('FAIL_TO_SET_NEW_CAMPAIGNS');
export const FAIL_TO_COMPLETE_CAMPAIGN       = createConstantVariable('FAIL_TO_COMPLETE_CAMPAIGN');
export const FAIL_TO_SEND_ENGAGEMENT_ANSWERS = createConstantVariable('FAIL_TO_SEND_ENGAGEMENT_ANSWERS');



// WEBPACK FOOTER //
// ./src/redux/campaigns/constants.js